module.exports = __webpack_public_path__ + "static/line-lottery-2ae44fad238e16c0289fd3f47a9187ed.jpg";